import BaseApiInstance from './base';
const BASE_URL = '/teams';

export const assignCouponApi = async (id, couponId) => {
  const response = await BaseApiInstance.patch(`${BASE_URL}/${id}/coupon`, {
    couponId,
  });
  return response;
};
